import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[commandColumnTemplate]',
})
export class CommandColumnTemplateDirective {
  @Input()
  align: 'start' | 'end' = 'start';

  @Input()
  width: number = -1;

  @Input()
  type: 'info' | 'edit' | 'delete' = 'info';

  @Input()
  title?: string;

  constructor(public template: TemplateRef<any>) {}
}
